/**
 * API関連の定数を定義するファイル
 */

// APIのベースURL
export const API_BASE_URL = '';

// 記事メタデータのURL
export const METADATA_URL = `${API_BASE_URL}/articles/metadata.json`;

// 訪問国データのURL
export const VISITED_COUNTRIES_URL = `${API_BASE_URL}/visited-countries.csv`; 